import React, { useEffect, useState, useCallback } from "react";
import ReservationForm from "./ReservationForm";
import { getStoreOptions, createMemberReservation, getMyReservations, cancelMyReservation } from "../api/reservation";
import { reservationStatusLabel, isCancellable } from "../utils/reservationStatus";

/** 로그인 회원용 예약 신청 + 내 예약 목록 (탭 전환). */
export default function MemberReservationPanel({ accessToken }) {
  const [tab, setTab] = useState("new"); // 'new' | 'mine'
  const [storeOptions, setStoreOptions] = useState([]);
  const [myList, setMyList] = useState([]);
  const [loadingMine, setLoadingMine] = useState(false);
  const [errorMine, setErrorMine] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    getStoreOptions().then((res) => setStoreOptions(res.data || [])).catch(() => setStoreOptions([]));
  }, []);

  const fetchMine = useCallback(async () => {
    setLoadingMine(true);
    setErrorMine("");
    try {
      const res = await getMyReservations(accessToken);
      setMyList(res.data || []);
    } catch (err) {
      setErrorMine(err.response?.data?.message || "예약 목록을 불러오지 못했습니다.");
    } finally {
      setLoadingMine(false);
    }
  }, [accessToken]);

  useEffect(() => { if (tab === "mine") fetchMine(); }, [tab, fetchMine]);

  const handleSubmit = async (payload) => {
    await createMemberReservation(payload, accessToken);
    setSuccessMsg("예약 신청이 접수되었습니다. 매장 확인 후 확정됩니다.");
    setTimeout(() => setSuccessMsg(""), 4000);
  };

  const handleCancel = async (reservationId) => {
    if (!window.confirm("이 예약을 취소하시겠습니까?")) return;
    try {
      await cancelMyReservation(reservationId, accessToken);
      fetchMine();
    } catch (err) {
      window.alert(err.response?.data?.message || "취소에 실패했습니다.");
    }
  };

  return (
    <div className="reservation-panel">
      <div className="reservation-tabs">
        <button className={tab === "new" ? "active" : ""} onClick={() => setTab("new")}>예약 신청</button>
        <button className={tab === "mine" ? "active" : ""} onClick={() => setTab("mine")}>내 예약</button>
      </div>

      {tab === "new" && (
        <>
          {successMsg && <p className="success">{successMsg}</p>}
          <ReservationForm storeOptions={storeOptions} onSubmit={handleSubmit} />
        </>
      )}

      {tab === "mine" && (
        <div className="reservation-list">
          {loadingMine && <p className="text-sub">불러오는 중...</p>}
          {!loadingMine && errorMine && <p className="error">{errorMine}</p>}
          {!loadingMine && !errorMine && myList.length === 0 && <p className="text-sub">예약 내역이 없습니다.</p>}
          {!loadingMine && !errorMine && myList.map((r) => (
            <div className="reservation-card" key={r.reservationId}>
              <div className="reservation-card-top">
                <strong>{r.storeName}</strong>
                <span className={`status-tag status-${r.reservationStatus}`}>{reservationStatusLabel(r.reservationStatus)}</span>
              </div>
              <div className="text-sub">{r.reservationDate} {(r.reservationTime || "").slice(0, 5)} · {r.partySize}명</div>
              {r.requestMemo && <div className="text-sub">요청사항: {r.requestMemo}</div>}
              {r.adminMemo && <div className="text-sub">매장 메모: {r.adminMemo}</div>}
              {isCancellable(r.reservationStatus) && (
                <button className="link-btn" onClick={() => handleCancel(r.reservationId)}>예약 취소</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
